import Calendar from './Calendar';
import Preview from './Contact';
import Confirmation from './Confirmation';
import ExistingAppointment from './ExistingAppointment';
import Appointment from './Appointment';

export default function init() {
    Calendar('Calendar', 'Pick a Time');
    Preview('Contact', 'Contact Information');
    Confirmation('Confirmation', 'Confirmation');
    Appointment('Appointment', 'Appointment');
    ExistingAppointment('ExistingAppointment', 'Welcome Back');
    ExistingAppointment('CancelledAppointment', 'Appointment Cancelled');
}


// WEBPACK FOOTER //
// ./src/app/pages/index.ts